import React from 'react';
import { XIcon, AlertTriangleIcon } from 'lucide-react';
interface ConfirmDeleteModalProps {
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  itemName?: string;
}
const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  onClose,
  onConfirm,
  title,
  message,
  itemName
}) => {
  return <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center" data-id="element-210">
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4" data-id="element-211">
        <div className="flex items-start justify-between p-4 border-b border-gray-200" data-id="element-212">
          <h3 className="text-xl font-semibold text-gray-900 flex items-center" data-id="element-213">
            <AlertTriangleIcon className="h-5 w-5 text-red-500 mr-2" data-id="element-214" />
            {title}
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500 focus:outline-none" aria-label="Close" data-id="element-215">
            <XIcon className="h-6 w-6" data-id="element-216" />
          </button>
        </div>
        <div className="p-6" data-id="element-217">
          <p className="text-gray-700 mb-4" data-id="element-218">{message}</p>
          {itemName && <div className="bg-gray-50 p-3 rounded-md border border-gray-200 mb-4" data-id="element-219">
              <p className="text-sm font-medium text-gray-900" data-id="element-220">{itemName}</p>
            </div>}
          <p className="text-sm text-red-600" data-id="element-221">This action cannot be undone.</p>
        </div>
        <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse border-t border-gray-200" data-id="element-222">
          <button type="button" onClick={onConfirm} className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm" data-id="element-223">
            Delete
          </button>
          <button type="button" onClick={onClose} className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" data-id="element-224">
            Cancel
          </button>
        </div>
      </div>
    </div>;
};
export default ConfirmDeleteModal;